export const getHttpStatus = (error: unknown): number | undefined => {
    const status = (error as { response?: { status?: unknown } } | null | undefined)?.response?.status;
    return typeof status === 'number' ? status : undefined;
};
